<template>
    <div class="pickerSearchWrapper">
      
      <div class="pickerActionArea">
        <input
          type="text"
          v-model="query"
          v-bind:placeholder="placeholder"
          class="pickerSearchInput"
          ref="gifSearchInput"
          autocomplete="false"
          @change.prevent="getGifSearch(query)"
        >
        <button @click.stop="getGifSearch(query)" class="btn green pickerSearchInputBtn">Search</button>
      </div>

      <div class="pickerSearchResults">
        <div v-if="loading" class="loading"></div>
        <template v-if="gifSearchResult.length > 0 && !loading">
          <img
            v-for="(gif, index) in gifSearchResult"
            :src="gif.images.fixed_width.url"
            :key="index"
            class="gifItem"
            @click.prevent="selectGif(gif.images.fixed_width.url)"
          >
        </template>
      </div>
    </div>
</template>

<script>
export default {
  name: 'gifSearch',
  props: {
    placeholder: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      query: '',
      loading: false,
      gifSearchResult: {
        type: Array,
        default: () => {
          return []
        }
      }
    }
  },
  mounted(){
    this.$refs.gifSearchInput.focus()
  },
  methods: {
    getGifSearch(query){
      this.loading = true
      this.gifSearchResult = []
      {
        this.$http.get(`https://api.giphy.com/v1/gifs/search?q=${query}&api_key=wIGtiuV9ajvhFwERGpBAOF68Gpm5eLy8`).then(response => {
          this.gifSearchResult = response.body.data
          this.loading = false
        }, error => {
          console.log('Gif search error: ', error)
          this.loading = false
        })
      }
    },
    reset(){
      this.query = ''
      this.gifSearchResult = []
    },
    selectGif(gifUrl){
      this.reset()
      this.$emit('onSelected', gifUrl)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GifSearch.vue